import type { FC } from "react";

import type { Action, ActionAction, FooterDataSdk, Pages } from "~/core";
import { Flex, Image, Markdown } from "~/shared/ui-kit";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

import { FooterControls } from "./components/FooterControls";
import { FooterMenu } from "./components/FooterMenu";

export type FooterV3Props = {
  data: FooterDataSdk;
  getUrl: (page: Pages) => string;
  onCallAction: (action: ActionAction) => void;
  isControlInactive: (control: Action) => boolean;
};
export const FooterV3: FC<FooterV3Props> = (props) => {
  const { data } = props;

  const { getDirectusImage } = useDirectus();
  return (
    <Flex
      as="section"
      justify="center"
      flexDirection="column"
      align="center"
      className="py-16"
    >
      <Image
        value={getDirectusImage(data?.logo?.id ?? "", {
          format: "webp",
          width: 190,
        })}
        mdValue={getDirectusImage(data?.logo?.id ?? "", {
          format: "webp",
          width: 252,
        })}
        className="w-fit text-center"
      />

      <FooterMenu {...props} />

      <FooterControls {...props} />

      <Markdown alignment="center">
        {data?.translations?.[0]?.description ?? ""}
      </Markdown>
    </Flex>
  );
};
